import React from 'react';
import Bio from './pages/main-page/index';

import './App.css';
function App() {
  return <Bio />;
}

export default App;
